<div class="p-4">
  <h2 class="text-xl font-bold mb-4">Agent-wise Interaction Summary</h2>

  <div class="d-flex gap-4 mb-4 justify-content-between">
    <div class="d-flex gap-4">
      <div class="gap-2 d-flex align-items-center">
        <label for="fromDate">Start Date</label
        ><input type="date" [(ngModel)]="fromDate" />
      </div>
      <div class="gap-2 d-flex align-items-center">
        <label for="toDate">End Date</label>
        <input type="date" [(ngModel)]="toDate" />
      </div>
      <button class="btn btn-primary" (click)="fetchSummary()">
        Fetch Summary
      </button>
    </div>
    <div>
      <button class="btn btn-success" (click)="exportAsExcelFromBackend()">
        Export As Excel
      </button>
    </div>
  </div>

  <div class="overflow-auto">
    <table class="table-auto w-full border border-gray-300">
      <thead class="bg-gray-100">
        <tr>
          <th class="border px-4 py-2">Agent Name</th>
          <th *ngFor="let note of callNoteHeaders" class="border px-4 py-2">
            {{ note }}
          </th>
          <th class="border px-4 py-2">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of pivotData"
          (click)="openAgentDetails(row.enteredBy)"
          class="cursor-pointer hover:bg-gray-100"
        >
          <td class="border px-4 py-2">{{ row.agentName }}</td>
          <td *ngFor="let note of callNoteHeaders" class="border px-4 py-2">
            {{ row[note] || 0 }}
          </td>
          <td class="border px-4 py-2">{{ row.total }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modal for Agent Details -->
  <div
    *ngIf="selectedAgentDetails"
    class="modal fade show d-block"
    tabindex="-1"
    style="background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <div>
            <h5 class="modal-title">Details for {{ selectedAgentName }}</h5>
            <p class="mb-0 mt-2">
              <strong class="text-danger">Due Today:</strong>
              {{ dueTodayCount }} &nbsp; | &nbsp;
              <strong class="text-warning">Due in Next 3 Days:</strong>
              {{ dueNext3DaysCount }}
            </p>
          </div>
          <div
            role="button"
            class="btn-close"
            aria-label="Close"
            (click)="selectedAgentDetails = null"
          ></div>
        </div>

        <div class="modal-body p-3">
          <div class="table-responsive">
            <table class="table table-bordered table-sm table-hover">
              <thead class="table-light">
                <tr>
                  <th>Customer</th>
                  <th>Phone</th>
                  <th>Interaction Date</th>
                  <th>Current Status</th>
                  <th>Next Action</th>
                  <th>Next Due Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let d of selectedAgentDetails">
                  <td>{{ d.customerName }}</td>
                  <td>{{ d.phoneNumber }}</td>
                  <td>{{ d.createdDate | date : "dd-MM-yyyy" }}</td>
                  <td>{{ d.outcomeStatus }}</td>
                  <td>{{ d.callNotes }}</td>
                  <td>{{ d.nextDueDate | date : "dd-MM-yyyy" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
